export interface IModelLoginRequest {
  clientId: string;
  username: string;
  password: string;
  remember_me: boolean;
  expires_in: string;
}

export interface IModelLoginResponse {
  credential: IModelLoginCredentialResponse;
}
export interface IModelLoginCredentialResponse {
  scopes: IModelLoginCredentialScopesResponse[];
  accessToken: string;
  refreshToken: string;
}
export interface IModelLoginCredentialScopesResponse {
  scope: string;
  hostName: string | null;
  urlPath: string | null;
}


export class ModelUserAuth {
  credential: ModelUserAuthCredential

  constructor(props = {} as IModelLoginResponse) {
    props = props ?? {}
    this.credential = new ModelUserAuthCredential(props.credential || {});
  }
}

export class ModelUserAuthCredential {
  scopeList: ModelUserAuthCredentialScopes[];
  accessToken: string;
  refreshToken: string;

  constructor(props = {} as IModelLoginCredentialResponse) {
    props = props ?? {};
    this.scopeList = (props.scopes || []).map(e => new ModelUserAuthCredentialScopes(e))
    this.accessToken = props.accessToken;
    this.refreshToken = props.refreshToken;
  }
}
export class ModelUserAuthCredentialScopes {
  scope: string;
  hostName: string | null;
  urlPath: string | null;

  constructor(props = {} as IModelLoginCredentialScopesResponse) {
    props = props ?? {}
    this.scope = props.scope;
    this.hostName = props.hostName;
    this.urlPath = props.urlPath;
  }
}


export interface IModelGETUserDetailDataResponse {
  id: number;
  adminConsoleId: number;
  username: string;
  email: string;
  phone: string;
  accessKeyId: string;
  secretAccessKeyId: string;
  status: string;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  avatar: string;
}

export class ModelGETUserDetail {
  id: number;
  adminConsoleId: number;
  username: string;
  email: string;
  phone: string;
  accessKeyId: string;
  secretAccessKeyId: string;
  status: string;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  avatarFilePath: string;
  avatarFile: any;

  constructor(props = {} as IModelGETUserDetailDataResponse) {
    props = props ?? {} as IModelGETUserDetailDataResponse;
    this.id = props.id || 0;
    this.adminConsoleId = props.adminConsoleId || 0;
    this.username = props.username || '';
    this.email = props.email || '';
    this.phone = props.phone || '';
    this.accessKeyId = props.accessKeyId || '';
    this.secretAccessKeyId = props.secretAccessKeyId || '';
    this.status = props.status || '';
    this.secretExpiredAt = props.secretExpiredAt || null;
    this.lastLoginAt = props.lastLoginAt || null;
    this.lastActiveAt = props.lastActiveAt || null;
    this.originAppId = props.originAppId || 0;
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.deletedAt = props.deletedAt || null;
    this.avatarFilePath = props.avatar ||'';
    this.avatarFile = this.avatarFilePath ? {
      url: this.avatarFilePath
    } : undefined;
  }
}